module.exports = __webpack_public_path__ + "static/media/payAtCounter.88e754bd.png";